import { IonContent, IonPage, } from '@ionic/react';
import React, { FormEvent } from 'react';
import styles from './css/Signup.module.css';
import Select from "react-dropdown-select";
import styled from "@emotion/styled";
import axiosInstance from '../services/AxiosInstance';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';


interface SignUpProps extends RouteComponentProps {
    // Define the props here
}

interface SignUpState {
    // Define the state here
    Organisations: Organisation[];
    SelectedValue: (string | object)[];
    Email: string;
    Achternaam: string;
    Voornaam: string;
    UserName: string;
    Password: string;
    Loading: boolean;
    LoadingOrgs: boolean;
}

interface LBL {
    label: string,
    value: number
}


interface OrgansiationInt {
    organisationName: string,
    id: number,
    toString(): string;
}

class Organisation implements OrgansiationInt {
    organisationName: string;
    id: number;

    constructor(name: string, id: number) {
        this.organisationName = name;
        this.id = id;
    }

    toString(): string {
        return this.organisationName;
    }

}

let StyledSelect = styled(Select)`
${({ dropdownRenderer }) =>
        dropdownRenderer &&
        `
      .react-dropdown-select-dropdown {
          overflow: initial;
      }
  `}
`;

const token = localStorage.getItem("complexToken");

class SignUp extends React.Component<SignUpProps, SignUpState>
{
    firstTimeOpen: boolean;
    constructor(props: SignUpProps) {
        super(props);

        this.state = {
            Organisations: [],
            SelectedValue: [],
            Email: "",
            Achternaam: "",
            Voornaam: "",
            Loading: false,
            UserName: "",
            Password: "",
            LoadingOrgs: true,
        }
        
        this.firstTimeOpen = true;        
    }

    componentDidMount() {
        this.GetOrganisationData();
      }

    handleDropdownOpen = () => {
        if (this.firstTimeOpen) {
          this.firstTimeOpen = false;
          this.forceUpdate(); // Force a visual update
          console.log("updating");
        }
      }

    GetOrganisationData() {
        axiosInstance.get(`/Organisations/`, { headers: { Authorization: `Bearer ${token}` } })
            .then((res) => {
                const orgs = res.data.map((org: Organisation) => new Organisation(org.organisationName, org.id));
                this.setState({
                    Organisations: orgs,
                    LoadingOrgs: false,
                });
                StyledSelect = styled(Select)`
                    ${({ dropdownRenderer }) =>
                            dropdownRenderer &&
                            `
                        .react-dropdown-select-dropdown {
                            overflow: initial;
                        }
                    `}
                    `;
            })
            .catch((err) => {
                console.log(err);
            });
    }


    handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        this.setState({ Loading: true });
        var ok = false;

        var passwordFormat =
            /^(?=.*\d.*)(?=.*[a-z].*)(?=.*[A-Z].*)(?=.*[^a-zA-Z0-9].*).{6,}$/gm;

        let emailFormat =
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        let OrgID: number;
        let selectOrg = (this.state.SelectedValue[0] as LBL);
        if (selectOrg == undefined) {
            OrgID = 0
        } else {
            OrgID = selectOrg.value
        }
        //let OrgID = 1;

        const config = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        };

        if (OrgID < 1) {
            alert("Gelieve je organisatie aan te duiden");
            this.setState({ Loading: false });
        } else if (this.state.Email == "") {
            alert("Gelieve een emailadres in te vullen");
            this.setState({ Loading: false });
        } else if (!emailFormat.test(this.state.Email.trim())) {
            alert("Gelieve een geldig emailadres in te vullen");
            this.setState({ Loading: false });
        } else if (this.state.Password == "") {
            alert("Gelieve een wachtwoord in te vullen");
            this.setState({ Loading: false });
        } else if (!passwordFormat.test(this.state.Password)) {
            alert(
                "Het wachtwoord moet minstens: 6 tekens lang zijn, een numerieke waarde, hoofdletter, kleine letter en speciaal teken bevatten. "
            );
            this.setState({ Loading: false });
        } else if (this.state.Voornaam == "") {
            alert("Gelieve je voornaam in te vullen");
            this.setState({ Loading: false });
        } else if (this.state.Achternaam == "") {
            alert("Gelieve je familienaam in te vullen");
            this.setState({ Loading: false });
        } else {
            ok = true;
        }

        if (ok) {
            try {
                axiosInstance.get("/Users/checkEmail/" + this.state.Email)
                    .then((res) => {
                        //console.log(res.data);
                        if (res.data) {
                            alert("Dit emailadres is al in gebruik. Gelieve een andere emailadres te gebruiken")
                            window.location.reload()
                        } else {
                            axiosInstance
                                .post(
                                    "/Users",
                                    {
                                        UserName: this.state.Email,
                                        Email: this.state.Email,
                                        FirstName: this.state.Voornaam,
                                        LastName: this.state.Achternaam,
                                        organisationId: OrgID,
                                        Password: this.state.Password,
                                    },
                                    config
                                )
                                .catch(() => {
                                    alert(
                                        "Er ging iets fout bij het aanmaken van jouw account. Wees zeker dat je wachtwoord minstens een hoofdletter, numerieke waarde en een cijfer bevat."
                                    );
                                    this.setState({ Loading: false });
                                })
                                .then(() => {
                                    this.setState({ Loading: false });

                                    //const { history } = this.props;
                                    //history.go(-1)
                                    axiosInstance.post("/Users/Authenticate", JSON.stringify(this.state), {
                                        headers: {
                                          Accept: "application/json",
                                          "Content-Type": "application/json",
                                          "Ocp-Apim-Subscription-Key": "cd4ed8b372ef47189706abe7ae615788",
                                        },
                                      }
                                      )
                                        .then((res) => {
                                          let user = res.data;
                                          if (user.roles[0] == "Employee") {
                                            localStorage.setItem("id", "" + user.id);
                                            localStorage.setItem("userName", user.userName);
                                            localStorage.setItem("token", user.jwtToken);
                                            localStorage.setItem("refreshToken", user.refreshToken);
                                            localStorage.setItem("organisationId", user.organisation);
                                            localStorage.setItem("firstName", user.voornaam);
                                            localStorage.setItem("lastName", user.familienaam);
                                            localStorage.setItem("role", user.roles[0]);
                                
                                            //Navigate to Portal
                                            this.goToPortal();
                                          } else {
                                            alert("Geen geldig email of wachtwoord.");
                                          }
                                        }).catch((err) => {
                                          console.error(err);
                                          alert("Geen geldig email of wachtwoord.");
                                          this.setState({ Loading: false });
                                        });
                                });
                        }
                    })


            } catch (e) {
                console.error(e);
            }
        }
    }

    goToPortal() {
        const { history } = this.props;
        const value = localStorage.getItem('WelcomeSeen' + localStorage.getItem("id"));
        if (!value) 
        {
            history.push("/WelcomeScreen");
        }
        else
        {
            history.push("/Portal");
        }        
      }

    handleMailAddrChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ Email: event.target.value });
    };

    handleVoornaamChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ Voornaam: event.target.value });
    };

    handleAchternaamChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ Achternaam: event.target.value });
    };

    handlePwdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ Password: event.target.value });
    };

    render() {
        const isDesktop = window.innerWidth > 768;

        return (
            <IonPage ion-no-header="true">
                <IonContent fullscreen ion-no-border="true">
                    <div style={{ backgroundImage: 'linear-gradient(#98CBFE, #339)', height: '100vh', width: '100wh', textAlign: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ marginTop: '1%', marginBottom: '-5%' }}>
                                <p className={`${styles.textFont} ${styles.headerText}`}>
                                    Registreren
                                </p>
                                <div className={(styles.logoView)}>
                                    <p className={`${styles.textFont} ${styles.logo}`}>
                                        WorkerPro
                                    </p>
                                    {isDesktop && (
                                        <p className={`${styles.textFont} ${styles.underlogo}`}>
                                            De intelligente mental wellbeing app
                                        </p>
                                    )}
                                </div>

                                <div style={{
                                    width: "85vw",
                                    height: "auto",
                                }}>
                                    <StyledSelect disabled={this.state.LoadingOrgs} values={[this.state.SelectedValue]} options={this.state.Organisations.map(org => ({ value: org.id, label: org.toString() }))}
                                    onChange={(value: (string | object)[]): void => {
                                        this.setState({ SelectedValue: value as (string | object)[] });
                                    }}
                                    style={{
                                        borderWidth: "1px",
                                        borderColor: "rgba(52, 52, 52, 0.0)",
                                        backgroundColor: "rgba(255, 255, 255, 1.0)",
                                        color: "black",
                                        fontFamily: "Comfortaa_400Regular",
                                        fontSize: "4vh",
                                        borderRadius: "5px",
                                        textOverflow: "ellipsis",
                                    }}
                                    onDropdownOpen={this.handleDropdownOpen}
                                    placeholder='Selecteer een onderneming...'
                                    
                                    />
                                </div>

                                <form onSubmit={this.handleSubmit}>
                                    <div className={styles.inputView}>
                                        <input name='MailAddr' className={styles.inputText} placeholder='E-mailadres' onChange={this.handleMailAddrChange} value={this.state.Email}></input>
                                    </div>
                                    <div className={styles.inputView}>
                                        <input name='Voornaam' className={styles.inputText} placeholder='Voornaam' onChange={this.handleVoornaamChange} value={this.state.Voornaam}></input>
                                    </div>
                                    <div className={styles.inputView}>
                                        <input name='Acthernaam' className={styles.inputText} placeholder='Familienaam' onChange={this.handleAchternaamChange} value={this.state.Achternaam}></input>
                                    </div>
                                    <div className={styles.inputView}>
                                        <input name='Password' className={styles.inputPwd} type='password' placeholder='Wachtwoord'
                                            value={this.state.Password}
                                            onChange={this.handlePwdChange} />
                                    </div>
                                    <div style={{ marginTop: "5vh" }}>
                                        <button disabled={this.state.Loading} className={(`${styles.button} ${styles.buttonText}`)} type='submit'>Registreren</button>
                                    </div>
                                </form>
                                <p className={`${styles.textFont} ${styles.info}`} style={{ marginBottom: "0px", marginTop: "2vh", fontSize: 10 }}>
                                    Door op registreren te klikken ga je accoord met onze <Link className={(styles.textFont)} style={{ fontSize: 10, color: "#FFF" }} to="/privacy"> Privacy Policy</Link>
                                </p>
                                <p className={`${styles.textFont} ${styles.info}`} style={{ marginBottom: "0px", fontSize: 10 }}>
                                    Al een account? <Link className={(styles.textFont)} style={{ fontSize: 10, color: "#FFF" }} to="/"> Inloggen</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        )
    };
}

export default withRouter(SignUp)
